<template>
  <div class="endTerritoryList">
    <div style="padding-bottom: 10px">终端辖区</div>
    <el-select v-model="territoryArr" filterable :filter-method="filterMethod" multiple style="width: 100%"
               popper-class="endTerritoryListPopper" clearable placeholder="请选择">
      <el-option
          v-for="item in list"
          :key="item.territory_id"
          :label="item.territory_name+`(${item.territory_code})`"
          :value="item.territory_id">
        <div style="padding: 10px 0;border-bottom:1px solid #eee ;">
          <div style="color: #4d586d;">
            <span>{{ item.territory_name }}</span>
            <span v-if="item.territory_code">({{ item.territory_code }})</span>
          </div>
          <div style="color: #b0b5b9; font-size: 12px;height:24px;display:flex;align-items:center">
            <span
                style="
                color: #fff;
                padding: 3px 3px;
                margin-right:4px;
                background: #ff9901;
                font-size: 12px;
                border-radius: 4px;
              "
            >{{ item.owner_name || "暂无" }}</span
            >
            职务：<span>{{ item.title || "暂无" }}</span>
          </div>
          <div
              v-if="(item.institution_num > '0' || item.retailstore_num > '0' || item.distributor_num > '0') "
              class="shuxian"
              style="font-size: 14px; color: #4a90e2;"
          >
            <span v-if="item.institution_num > '0'"
            >机构&nbsp;{{ item.institution_num }}家</span
            >
            <span v-if="item.retailstore_num > '0'"
            >门店&nbsp;{{ item.retailstore_num }}家</span
            >
            <span v-if="item.distributor_num > '0'"
            >经销商&nbsp;{{ item.distributor_num }}家</span
            >
          </div>
        </div>
      </el-option>
    </el-select>
    <div class="All">
      <el-checkbox
          @change="selectAll"
          fill="#FF9901"
          v-model="checked"
      ></el-checkbox>
      <span>选中以上所有终端辖区</span>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import http from "../../../APIService/http";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  props: {
    value: {
      type: Array,
      defaultValue: [],
    },
    month: {
      type: String,
      defaultValue: moment().format("YYYY-MM"),
    },
    territoryId: {
      type: String,
      defaultValue: "",
    },
  },
  data() {
    return {
      list: [],
      listCopy: [],
      checked: false,
      territoryArr: [],
      territoryDatas: [],
      mySwiper: null,
    };
  },
  mounted() {

     this.getTerritoryList();
  },
  computed: {
    territoryLen() {
      return this.territoryArr.length;
    },
  },
  watch: {
    month: {
      handler: function (val, old) {
        this.getTerritoryList();
      },
      immediate: true
    },
    territoryId:{
      handler: function (val, old) {
        this.getTerritoryList();
      },
      immediate: true
    },
    territoryLen(val, old) {
      if (val != old && this.list.length > 0) {
        if (val === this.territoryDatas.length) {
          this.checked = true;
        } else {
          this.checked = false;
        }
        let data = this.territoryArr.map((item) => {
          return this.list.filter((i) => i.territory_id === item)[0];
        });

        this.$emit("change", data);
      }
    },
  },
  methods: {
    filterMethod(val) {
      if (val) {
        this.list = this.listCopy.filter(v => {
          if (v.territory_name.includes(val) || v.territory_code.includes(val)) {
            return true
          }
        })
      } else {
        this.list = this.listCopy
      }
    },

    selectAll(val) {
      if (val) {
        this.territoryArr = [...this.territoryDatas];
      } else {
        if (this.territoryArr.length === this.territoryDatas.length) {
          this.territoryArr = [];
        }
      }
      //   let data = this.territoryArr.map((item) => {
      //     return this.list.filter((i) => i.territory_id === item)[0];
      //   });
      //   this.$emit("change", data);
    },
    selectItem(id) {
      if (this.territoryArr.includes(id)) {
        this.territoryArr.splice(this.territoryArr.indexOf(id), 1);
        this.checked = false;
      } else {
        this.territoryArr.push(id);
        if (this.territoryArr.length === this.territoryDatas.length) {
          this.checked = true;
        }
      }
      //   let data = this.territoryArr.map((item) => {
      //     return this.list.filter((i) => i.territory_id === item)[0];
      //   });
      //   this.$emit("change", data);
    },
    getTerritoryList() {
      this.territoryArr = this.value;
      let query = {
        tenant_id: this.$store.getters.getUser.tenant_id || "",
        user_id: this.$store.getters.getUser.user_id || "",
        territory_id: this.territoryId || "",
        month: this.month || moment().format("YYYY-MM"),
      };
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      http.post("b2b_sever/gkGetFeedback/getChildTerritoryList", query).then((res) => {
        loading.close()
        this.list = res.data;
        this.listCopy = res.data;
        this.territoryDatas = this.list.map((item) => item.territory_id);
        let data = this.value.map((item) => {
          return this.list.filter((i) => i.territory_id === item)[0];
        });
        this.$emit("change", data);
        if (this.value.length === 0) {

        } else if (this.territoryDatas.length === this.value.length) {
          this.checked = true;
        }
      }).catch((e) => {
        loading.close()
        this.$message.error('终端辖区列表获取失败！')
      })
    },
  },
};
</script>

<style>

#swiperTerr {
  margin: 0 10px;
  height: 86px;
}

.endTerritoryListPopper .el-select-dropdown__item {
  height: auto !important;
  line-height: inherit !important;

}

.endTerritoryListPopper .el-select-dropdown__item.selected:after {
  content: '1';
  position: absolute;
  right: 20px;
  top: 50%;
  color: #fff;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  background: #ff9901;
  border-radius: 50%;
  margin-top: -7px;
}

.endTerritoryList {
  padding: 0 20px;
}


.endTerritoryList .item {
  height: 86px;
  width: auto;
  min-width: 260px;
  padding: 10px;
  box-sizing: border-box;
  background: rgba(74, 144, 226, 0.1);
  margin-right: 10px;
  border: 1px solid #fff;
}

.endTerritoryList .item:last-child {
  margin-right: 0;
}

.endTerritoryList .itemSelect {
  border: 1px solid #4a90e2;
}

.endTerritoryList .All {
  color: #4a90e2;
  font-size: 14px;
  margin-top: 10px;
  padding-left: 20px;
}

.endTerritoryList .shuxian > span {
  display: inline-block;
  padding-right: 6px;
  padding-left: 4px;
  position: relative;
}

.endTerritoryList .shuxian > span:first-child {
  padding-left: 0;
}

.endTerritoryList .shuxian > span:after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 1px;
  background: #4a90e2;
  height: 14px;
}

.endTerritoryList .shuxian span:last-child::after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesdata/components/endTerritoryList.vue